module.exports = __webpack_public_path__ + "static/client6-7c813adee14c746c19b65ef07d3258a0.png";